import { combineReducers } from "redux";
import cardsById from "./cardsById";
import listsById from "./listsById";
import boardsById from "./boardsById";
import boardUsers from "./boardUsers";
import user from "./user";
import currentBoardId from "./currentBoardId";
import boardType from "./boardType";
import theme from "./theme";
import sprintsById from "./sprintsById";
import currentSprintId from "./currentSprintId";
import searchTerm from "./searchTerm";

const rootReducer = combineReducers({
  cardsById,
  listsById,
  boardsById,
  user,
  theme,
  boardUsers,
  currentBoardId,
  boardType,
  sprintsById,
  currentSprintId,
  searchTerm
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
